import { atom } from 'jotai';
import { IRateViewModel } from './atomConfig';

const ratesAtom = atom<IRateViewModel[]>([]);
ratesAtom.debugLabel = 'ratesAtom';

export default ratesAtom;
